import React from 'react'
import Reflux from 'reflux-react-16'

import Alert from '../UI/feedback/Alert.js'
import Button from '../UI/buttons/Button.js'
import {Tab, Tabs} from '../UI/tabs/index.js'
import Card from '../UI/surfaces/Card.js'
import {formSpacing, Input} from '../UI/forms/index.js'

import UtilStore from '../../stores/UtilStore.js'
import UtilActions from '../../actions/UtilActions.js'

class EmailPreview extends Reflux.Component {
    constructor(props) {
        super(props)

        this.state = {
            view: 'desktop'
        }

        this.store = UtilStore
    }

    onClickSendPreview() {
        const {type, notification, action, language = 'NL'} = this.props
        const {email} = this.state

        this.setState({loading: true, message: '', error: ''})

        UtilActions.sendEmailPreview(email, type, notification, action, language, (err, response) => {
            if (err) {
                this.setState({loading: false, message: '', error: err})
            } else {
                this.setState({loading: false, message: response, error: ''})
            }
        })
    }

    render() {
        const {loading, message, error} = this.state
        const {html, disabled} = this.props

        return (
            <div style={{width: '100%', height: '100%'}}>
                <div style={{display: 'flex', alignItems: 'center', columnGap: formSpacing.columnGap, marginBottom: 24}}>
                    {this.state.view === 'mobile' &&
                        <Tabs
                            value={this.state.view}
                            onChange={(event) => this.setState({view: event.target.value})}
                            style={{marginBottom: 30, marginRight: 8}}
                        >
                            <Tab size='sm' value='desktop'>
                                <i className='mdi mdi-monitor' />
                            </Tab>
                            <Tab size='sm' value='mobile'>
                                <i className='mdi mdi-cellphone' />
                            </Tab>
                        </Tabs>
                    }

                    <Input
                        style={{width: 240}}
                        label='Emailadres'
                        value={this.state.email}
                        onChange={(event) => this.setState({email: event.target.value, message: '', error: ''})}
                        disabled={disabled}
                    />

                    <Button
                        loading={loading}
                        disabled={disabled}
                        onClick={() => this.onClickSendPreview()}
                    >
                        Verstuur voorbeeld
                    </Button>
                </div>

                <div style={{height: 55, marginTop: -25}}>
                    {message &&
                        <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>
                    }

                    {error &&
                        <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                    }
                </div>

                <Card shadow style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div dangerouslySetInnerHTML={{__html: html}} />
                </Card>
            </div>
        )
    }
}

export default EmailPreview
